import { getAllPermissions } from '../../api/usersModule/getters';
import defaultModules from './modules';
import clone from 'just-clone';

const getPermissions = async (user) => {
	const permissions = await getAllPermissions(
		user.attributes.email,
		user.attributes['custom:project']
	);
	return permissions;
};

export const filteredModules = async (user, setModules) => {
	try {
		const modulesCopy = clone(defaultModules);
		const permissions = await getPermissions(user);
		console.log('=== DEBUG: Permisos obtenidos ===');
		console.log('Todos los permisos:', permissions);
		console.log('¿Tiene "Distribución Diaria"?', permissions['Distribución Diaria']);
		console.log('¿Tiene "Detalle Inventario"?', permissions['Detalle Inventario']);
		console.log('================================');
		const filteredModules = modulesCopy.filter((mod) => {
			if (mod.isSubmenu) {
				mod.items = mod.items.filter((item) => {
					const hasPermission = permissions[item.name] && permissions[item.name].Consultar;
					console.log(`Item: ${item.name}, Permiso: ${hasPermission}`);
					return hasPermission;
				});
				return mod.items.length > 0;
			} else {
				return permissions[mod.name] && permissions[mod.name].Consultar;
			}
		});
		console.log('=== MÓDULOS FILTRADOS ===');
		console.log('Cantidad de módulos filtrados:', filteredModules.length);
		filteredModules.forEach((mod, idx) => {
			console.log(`Módulo ${idx}: ${mod.label || mod.name}`);
			if (mod.isSubmenu) {
				console.log(`  Items (${mod.items.length}):`, mod.items.map(i => i.label).join(', '));
			}
		});
		console.log('========================');
		setModules(filteredModules);
	} catch (error) {
		console.error(error);
		setModules([]);
	}
};
